module.exports = __webpack_public_path__ + "static/media/Gotham Rounded Medium.29c9cff4.woff";